export default {
      id: "printer-usage",
      viewBox: "0 0 33.75 33.751",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#printer",
      toString: function () {
        return this.url;
      }
    }